import rateCards from '../constants/businessUsersRateCards.json';
import livePlanStatus from '../constants/usersLivePlanStatus.json';
import { isProd } from 'constants/env';

export const showNewSubLink = (user) =>
  user?.address && user?.address?.length > 0;
export const showRessellerOrderDeviceLink = (user) =>
  (user?.acl_group_name === 'RESELLER' ||
    user?.acl_group_name === 'RESOLD_USER') &&
  user?.reference === 'WITV';

export const getRateCardLink = (userId) => {
  if (isProd()) {
    return rateCards[userId];
  } else {
    // only for test purpose on stage
    return rateCards['2348'];
  }
};

export const getLivePlanStatus = (user) => {
  if (!user || !user.id) {
    return '';
  }

  if (isProd()) {
    return livePlanStatus[user.id];
  } else {
    // only for test purpose on stage
    return user.acl_group_name === 'BUSINESS' ||
      user.acl_group_name === 'RESELLER'
      ? livePlanStatus['171105']
      : '';
  }
};
